import { getApiBaseUrl, getConfiguredNodeEnv, getRuntimeConfig, getServerUrl } from '../config/runtimeConfig';

// Function to dynamically determine the backend URL based on runtime config
const getBackendUrl = () => {
  const runtimeConfig = getRuntimeConfig();
  const serverUrl = getServerUrl();

  // Debug information with more context
  const envInfo = {
    NODE_ENV: process.env.NODE_ENV,
    RUNTIME_CONFIG: runtimeConfig,
    serverUrl,
    REACT_APP_NODE_ENV: getConfiguredNodeEnv(),
    isWindowDefined: typeof window !== 'undefined',
    currentOrigin: typeof window !== 'undefined' ? window.location.origin : 'not in browser',
    currentHostname: typeof window !== 'undefined' ? window.location.hostname : 'not in browser'
  };
  
  console.log('🔧 API Config - Environment Information:', envInfo);
  console.log('✅ Using resolved server URL:', serverUrl);
  return getApiBaseUrl();
};

const apiConfig = {
  baseURL: getBackendUrl(),
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  // Set withCredentials to align with backend CORS configuration
  withCredentials: true, 
  // Add explicit CORS settings
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  timeout: 10000, // 10 second timeout
  // Ensure errors are properly handled and reported
  validateStatus: status => status >= 200 && status < 300
};

// Export the getBackendUrl function
export { getBackendUrl };

export default apiConfig;